<!-- 采购单提取单据 -->
<template>
<div>
    <div class="page_content_top_line">
        <el-form :inline="true" :model="getRequestData" class="demo-form-inline" v-if="pageShowData[0]" size="mini">
            <el-form-item v-if="formOneValue.isShow==1"  :label="formOneValue.showField"  v-for="(formOneValue,formOneKey) in pageShowData[0].jurconfigform" :key="formOneKey">
                    <el-input v-if="formOneValue.entityField == 'vmLicensecode'" @focus="openSearch(formOneValue.searchId, 'vmLicensecode')" v-model.trim="getRequestData.smName" :maxlength="$store.state.inputLength" clearable ></el-input>
                <el-date-picker v-else-if="formOneValue.entityField == 'start'" v-model="getRequestData[formOneValue.entityField]" type="date" placeholder="选择日期" format="yyyy 年 MM 月 dd 日" value-format="timestamp" clearable></el-date-picker>
                <el-date-picker v-else-if="formOneValue.entityField == 'end'" v-model="getRequestData[formOneValue.entityField]" type="date" placeholder="选择日期" format="yyyy 年 MM 月 dd 日" value-format="timestamp" clearable></el-date-picker>
                <el-input v-else v-model.trim="getRequestData[formOneValue.entityField]" :maxlength="$store.state.inputLength" clearable></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" size="mini" @click="getTableMainList">查询</el-button>
            </el-form-item>

        </el-form>
    </div>
    <!-- 表格 -->
    <el-table v-if="pageShowData[1]" stripe :data="returnData.list" border style="width: 100%" highlight-current-row size="mini" @selection-change="mainSelectionChange">
        <el-table-column type="selection" width="50"></el-table-column>
        <!-- 主表单 -->
        <el-table-column v-if="tableValye.isShow==1"  v-for="(tableValye,tableKey) in pageShowData[1].jurconfigtable" :key="tableKey" :prop="tableValye.entityField" :label="tableValye.showField" show-overflow-tooltip :min-width="tableValye.fieldWeight">
            <template  slot="header">
                <div>
                    <el-tooltip :content="tableValye.showField" placement="top">
                        <div class="long_title"><span>{{tableValye.showField}}</span></div>
                    </el-tooltip>
                </div>
            </template>
            <template slot-scope="scope">
                <!-- 状态 -->
                <template v-if="tableValye.entityField == 'psomState'">
                    <el-tag v-if="tableValye.formatterContent" size="mini">{{$common.getIsGsp(tableValye.formatterContent,scope.row.psomState)}}</el-tag>
                </template>

                <el-tag v-else-if="tableValye.entityField == 'isWms'" size="mini">{{scope.row[tableValye.entityField]==0? '否': '是'}}</el-tag>

                <!-- 购进日期 -->
                <template v-else-if="tableValye.entityField == 'psomBuydate'">
                    <span v-if="scope.row[tableValye.entityField]">
                        {{ $common.getLocalTime(item.finishTime) }}
                    </span>
                </template>

                <span v-else>{{scope.row[tableValye.entityField]}}</span>
            </template>
        </el-table-column>
    </el-table>

    <div style="margin-top: 1rem;text-align: center;">
        <el-button @click="sureDetail" type="primary">确认选择</el-button>
    </div>
</div>
</template>

<script>
export default {
    name: "unLoadingRecordListAction",
    components: {},
    data() {
        return {
            getRequestData: {
                start: '',
                end: '',
                "creater": '',
                "ormId": '',
                "cmName": '',
                "opmId": '',
                "page": '',
                "rows": '',
            },
            returnData: [],
            selectedDataIndexList: [],
        };
    },

    props: {
        pageShowData:{
            type: Array,
            require: true
        },
    },
    watch: {},
    computed: {},
    mounted() {},
    created() {
        // 处理组件需要的数据
        this.getTableMainList()
    },
    methods: {
        //主单选择
        mainSelectionChange(val) {
            this.selectedDataIndexList = []
            val.forEach(v => {
                this.selectedDataIndexList.push(v.psomId)
            })
        },
        //确认选择
        sureDetail() {
            if(this.selectedDataIndexList.length<1){
                this.$message({
                    message: '请先选择数据',
                    type: 'error'
                })
                return false
            }

            let str = this.selectedDataIndexList.join(',')
            this.$emit("loadingRecordReturn", str)
        },
        // 获取主表格
        async getTableMainList() {
            let res = await this.$http.unloadQueryOrder(this.getRequestData)
            console.log(res);
            if (res && res.status == 200) {
                this.returnData = res.result; //默认第一条
            } else {
                this.$message({
                    message: res.message,
                    type: 'error'
                })
                return false
            }
        },


    },
};
</script>

<style scoped>
</style>
